// extracted by mini-css-extract-plugin
export default {"tabBodyItemActive":"index_tabBodyItemActive_G8pON","tabBodyItem":"index_tabBodyItem_tT8hB"};